/** PrimeNG TreeNode-compatible tree node shape. */
export interface DocTreeNode {
  label?: string;
  data?: Record<string, unknown> | null;
  icon?: string;
  expanded?: boolean;
  children?: DocTreeNode[];
  leaf?: boolean;
  selectable?: boolean;
  key?: string;
  styleClass?: string;
  type?: string;
}

export interface DocTreeNodeSelectEvent {
  node: DocTreeNode;
  originalEvent?: Event;
}

export function docTreeNodesMatch(a: DocTreeNode | null | undefined, b: DocTreeNode | null | undefined): boolean {
  if (!a || !b) {
    return false;
  }

  if (a === b) {
    return true;
  }

  if (a.key != null && b.key != null && a.key === b.key) {
    return true;
  }

  const aId = a.data?.['folderId'] ?? a.data?.['entityId'] ?? a.data?.['FolderId'];
  const bId = b.data?.['folderId'] ?? b.data?.['entityId'] ?? b.data?.['FolderId'];
  const aLibrary = a.data?.['libraryType'];
  const bLibrary = b.data?.['libraryType'];

  return aId != null && bId != null && aId === bId && aLibrary === bLibrary;
}

export function getDocTreeNodeField(node: DocTreeNode, field: string): unknown {
  if (field === 'label') {
    return node.label;
  }

  if (field.startsWith('data.')) {
    return node.data?.[field.slice(5)];
  }

  return (node as Record<string, unknown>)[field];
}
